export * from "./customers-landing-page-relay.template";
export { CustomersLandingPageRelayTemplate as Default } from "./customers-landing-page-relay.template";
